import CampaignDetails from "../components/Campaigns/CampaignDetails";

function CampaignDetailsPage() {
    return (
        <CampaignDetails />
    )
}

export default CampaignDetailsPage;